<template>
  <div>
    <Drawer
      :title="changeModalTitle"
      v-model="changeModal"
      width="550"
      @on-cancel="formReset"
      :mask-closable="true">
      <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
      <Form :model="changeForm" ref="changeForm" :rules="changeRule" :label-width="90">
        <FormItem prop="name" label="云硬盘名称">
          <Input v-model="changeForm.name" placeholder="填写云硬盘名称" :maxlength="128" />
        </FormItem>
        <FormItem prop="description" label="描述">
          <Input v-model="changeForm.description" type="textarea" :rows="3" :maxlength="255" />
        </FormItem>
        <div v-if="!fixed_model_id">
          <FormItem label="云硬盘来源" v-if="!changeForm.id" prop="volume_source">
            <Select v-model="changeForm.volume_source" clearable placeholder="">
              <Option value="blank" key="blank">空白云硬盘</Option>
              <Option value="snapshot" key="snapshot">快照</Option>
              <Option value="image" key="image">镜像</Option>
              <Option value="volume" key="volume">云硬盘</Option>
            </Select>
          </FormItem>
          <FormItem label="选择源快照" prop="snapshot_id" v-if="changeForm.volume_source === 'snapshot' && !changeForm.id">
            <Select v-model="changeForm.snapshot_id">
              <Option v-for="item in snapshotList" :key="item.id" :value="item.id">{{ item.name }} ({{ item.size }} GiB)</Option>
            </Select>
          </FormItem>
          <FormItem label="选择源云硬盘" prop="source_volid" v-else-if="changeForm.volume_source === 'volume' && !changeForm.id">
            <Select v-model="changeForm.source_volid">
              <Option v-for="item in volumeList" :key="item.id" :value="item.id">{{ item.name }} ({{ item.size }} GiB)</Option>
            </Select>
          </FormItem>
          <FormItem label="选择源镜像" prop="imageRef" v-else-if="changeForm.volume_source === 'image' && !changeForm.id">
            <Select v-model="changeForm.imageRef">
              <Option v-for="item in imageList" :key="item.id" :value="item.id" v-if="item.owner === $store.state.privateCloud.selPrivateCloudProject || item.visibility !== 'private'">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </div>
        <FormItem label="云硬盘类型" v-if="!changeForm.id" prop="volume_type">
          <Select v-model="changeForm.volume_type" clearable placeholder="">
            <Option v-for="item in volumeType" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="大小(GiB)" prop="size" v-if="!changeForm.id">
          <InputNumber :min="1" v-model="changeForm.size" style="margin-right: 10px" />
          <tooltip placement="right" transfer max-width="200">
            <Icon type="ios-help-circle-outline" size="18" />
            <div slot="content">
              <p>如果选择云硬盘作为源，云硬盘大小必须大于或等于源云硬盘的大小</p>
            </div>
          </tooltip>
        </FormItem>
        <div v-if="!fixed_model || fixed_model === 'image'">
          <FormItem prop="availability_zone" label="区域" v-if="changeForm.volume_source !== 'volume' && changeForm.volume_source !== 'snapshot' && !changeForm.id">
            <RadioGroup v-model="changeForm.availability_zone" type="button">
              <Radio :label="item.zoneName" v-for="item in availabilityZoneList" :key="item.zoneName" v-if="item.zoneState && item.zoneState.available"></Radio>
            </RadioGroup>
          </FormItem>
        </div>
        <FormItem>
          <Button type="primary" @click="changeSubmit" :loading="changeLoading">提交</Button>
          <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
        </FormItem>
      </Form>
    </Drawer>
  </div>
</template>

<script>
import { changePrivateCloudVolume, getPrivateCloudAllVolume, getPrivateCloudVolumeType } from '@/api/private-cloud/volume'
import { getPrivateCloudAllVolumeSnapshot } from '@/api/private-cloud/volume-snapshot'
import { getPrivateCloudAllImage } from '@/api/private-cloud/image'
import { getPrivateCloudAvailabilityZones } from '@/api/private-cloud/availability-zone'

export default {
  name: 'volume-edit',
  data () {
    return {
      changeModalTitle: '创建云硬盘',
      changeModal: false,
      changeLoading: false,
      volumeType: [],
      changeForm: {
        id: '',
        name: '',
        description: '',
        volume_source: 'blank',
        snapshot_id: '',
        source_volid: '',
        imageRef: '',
        volume_type: '',
        size: null,
        availability_zone: ''
      },
      changeRule: {
        name: [
          { required: true, message: '云硬盘名称不能为空', trigger: 'blur' }
        ],
        volume_source: [
          { required: true, message: '请选择云硬盘来源', trigger: 'change' }
        ],
        snapshot_id: [
          { required: true, message: '请选择快照', trigger: 'change' }
        ],
        source_volid: [
          { required: true, message: '请选择云硬盘', trigger: 'change' }
        ],
        imageRef: [
          { required: true, message: '请选择镜像', trigger: 'change' }
        ],
        availability_zone: [
          { required: true, message: '请选择可用域', trigger: 'change' }
        ],
        size: [
          { required: true, type: 'number', message: '请填写云硬盘大小', trigger: 'blur' }
        ]
      },
      fixed_model: '',
      fixed_model_id: '',
      errorMsg: '',
      errorMsgShow: false,
      snapshotList: [],
      imageList: [],
      volumeList: [],
      availabilityZoneList: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.formReset()
      this.getSnapshotList()
      this.getImageList()
      this.getVolumeList()
      this.getAvailabilityZoneListData()
      this.getVolumeTypeData()
    },
    // 获取云硬盘类型列表数据
    getVolumeTypeData () {
      getPrivateCloudVolumeType().then(res => {
        this.volumeType = res.data.volume_types
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取云硬盘类型列表失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取云硬盘类型列表失败！'
          })
        }
      })
    },
    // 打开创建模式
    openModal (model, row) {
      this.formReset()
      if (model && !row.id) {
        this.$Notice.error({ title: '请选择源' })
        return
      }
      if (model) {
        this.fixed_model = model
        this.changeForm.name = row.name
        this.fixed_model_id = row.id
        if (model === 'snapshot') {
          if (row.size) {
            this.changeForm.size = row.size
          }
          this.changeModalTitle = '从快照「' + row.name + '」创建云硬盘'
        } else if (model === 'image') {
          if (row.size) {
            this.changeForm.size = Math.floor(row.size / 1024 / 1024 / 1024) + 1
          }
          this.changeModalTitle = '从镜像「' + row.name + '」创建云硬盘'
        } else {
          this.changeModalTitle = '创建云硬盘'
        }
      } else {
        this.changeModalTitle = '创建云硬盘'
      }
      this.changeModal = true
    },
    // 打开修改模式
    modifyOpenModal (row) {
      this.formReset()
      this.changeForm.id = row.id
      this.changeForm.name = row.name
      this.changeForm.description = row.description
      this.changeModalTitle = '[' + row.name + '] 编辑'
      this.changeModal = true
    },
    // 通用表单重置
    formReset () {
      this.changeForm = {
        id: '',
        name: '',
        description: '',
        volume_source: 'blank',
        source_volid: '',
        imageRef: '',
        size: null,
        availability_zone: this.changeForm.availability_zone
      }
    },
    // 提交云硬盘编辑表单
    changeSubmit () {
      this.$refs.changeForm.validate((valid) => {
        if (valid) {
          let reqData = {
            name: this.changeForm.name,
            description: this.changeForm.description,
            size: this.changeForm.size,
            volume_type: this.changeForm.volume_type
          }
          if (this.fixed_model) {
            if (this.fixed_model === 'snapshot') {
              reqData.snapshot_id = this.fixed_model_id
            } else if (this.fixed_model === 'volume') {
              reqData.source_volid = this.fixed_model_id
            } else if (this.fixed_model === 'image') {
              reqData.imageRef = this.fixed_model_id
              reqData.availability_zone = this.changeForm.availability_zone
            }
          } else if (!this.changeForm.id) {
            if (this.changeForm.volume_source === 'snapshot') {
              reqData.snapshot_id = this.changeForm.snapshot_id
            } else if (this.changeForm.volume_source === 'volume') {
              reqData.source_volid = this.changeForm.source_volid
            } else if (this.changeForm.volume_source === 'image') {
              reqData.imageRef = this.changeForm.imageRef
              reqData.availability_zone = this.changeForm.availability_zone
            }
          }
          this.changeLoading = true
          changePrivateCloudVolume(reqData, this.changeForm.id).then(res => {
            this.errorMsgShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.$emit('editComplete')
            this.changeModal = false
            this.getVolumeList()
            this.formReset()
            this.changeLoading = false
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    },
    // 获取快照列表
    getSnapshotList () {
      getPrivateCloudAllVolumeSnapshot().then(res => {
        this.snapshotList = res.data
      }).catch(res => {
        console.log(res.response)
      })
    },
    // 获取镜像列表
    getImageList () {
      getPrivateCloudAllImage().then(res => {
        this.imageList = res.data
      }).catch(res => {
        console.log(res.response)
      })
    },
    // 获取云硬盘列表
    getVolumeList () {
      getPrivateCloudAllVolume({ status: 'available' }).then(res => {
        this.volumeList = res.data
      }).catch(res => {
        console.log(res.response)
      })
    },
    // 获取可用域列表
    getAvailabilityZoneListData () {
      getPrivateCloudAvailabilityZones().then(res => {
        this.availabilityZoneList = res.data
        if (res.data.length) {
          this.changeForm.availability_zone = res.data[0].zoneName
        }
      }).catch(res => {
        console.log(res.response)
      })
    }
  }
}
</script>

<style scoped>

</style>
